objectFitImages();

var roomSlider = new Swiper('.js-carousel', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});

/**
 * ทำงานเกี่ยวกับการเช็กขนาดของ Element และ return คลาสตามเงื่อนไข
 * @since 2019-06-26
 * @param {DOM} el 
 */
function detectCouponSize(el) {  
  if (el.clientWidth < 220) {
    el.classList.add('sm');
  } else {
    el.classList.remove('sm');
  }

  if (el.clientWidth >= 360 ) {
    el.classList.add('lg');
  } else {
    el.classList.remove('lg');
  }
}

if ( document.querySelector('.deal-coupon') ) {
  var _coupons = document.querySelectorAll('.deal-coupon');

  window.addEventListener('load', () => {
    _coupons.forEach(el => detectCouponSize(el));
  });

  window.addEventListener('resize', () => {
    _coupons.forEach(el => detectCouponSize(el));
  });
}

/**
 * ทำงานเกี่ยวกับการสลับตำแหน่ง widget ระหว่างหน้าจอที่ต่ำหกว่า 768px และหน้าจอที่สูงกว่า
 * @since 2019-06-26
 */
var widgetPositioning = () => {
  const _sidebarSide = document.querySelector('.post-rate__sidebar--side');
  const _sidebarBottom = document.querySelector('.post-rate__sidebar--bottom');
  const _widgetSubscribe = document.querySelector('#widget_subscribe');
  const _widgetShare = document.querySelector('#widget_rate_share');

  if ( window.innerWidth >= 768 ) {
    if (!_sidebarSide.querySelector('#widget_share')) {
      _sidebarSide.appendChild(_widgetShare);
      _sidebarSide.appendChild(_widgetSubscribe);
    }
  } else {
    if (!_sidebarBottom.querySelector('#widget_share')) {
      _sidebarBottom.appendChild(_widgetShare);
      _sidebarBottom.appendChild(_widgetSubscribe);
    }
  }
}

if (window.TL.ui.WidgetPositioning === undefined) {
  window.TL.ui.WidgetPositioning = widgetPositioning;
}

window.addEventListener('DOMContentLoaded', TL.ui.WidgetPositioning);
window.addEventListener('resize', TL.ui.WidgetPositioning);
 
var initCalendar = function() {
    
var $form = $('#booking_package_form');
var $packageCalendar = $('#package_calendar');
var $packageCalendarPrev = $packageCalendar.find('.tl-datepicker__nav-prev');
var $packageCalendarNext = $packageCalendar.find('.tl-datepicker__nav-next');
var minDateBase;
var packageCalendar = new Calendar($packageCalendar, {
  children: '.calendar',
  minDate: new Date($('#h_checkin').val()),
  checkRange: [],
  onInit({minDate, maxDate, month, checkRange}) {
    var range = checkRange;  
    minDateBase = minDate;
    setCheckInOutUI(range[0], range[1]);
    setCheckInOutFields(range[0], range[1]);
    calendarNavState(minDate, maxDate, month);
    $form.find('.calendar-week').html(this.renderWeek());
  },
  onDateSelect() {
    var range = this.settings.checkRange;

    switch (range.length) {
      case 0:
        setCheckInOutFields(null, null);
        setCheckInOutUI(null, null);
        break;
      case 1:
        setCheckInOutFields(range[0], null);
        setCheckInOutUI(range[0], null);
        break;
      case 2:
        setCheckInOutFields(range[0], range[1]);
        setCheckInOutUI(range[0], range[1]);
        break;
    }
  },
  onChange({minDate, maxDate, month}) {
    calendarNavState(minDate, maxDate, month);
  }
});

function calendarNavState(minDate, maxDate, month) {
  $packageCalendarPrev.prop('disabled', () => moment(month).isBefore(minDate));
  $packageCalendarNext.prop('disabled', () => moment(month).isAfter(maxDate));
}

function setCheckInOutFields(checkin, checkout) {
  var checkinDate = Date.parse(checkin) ? moment(checkin).format('YYYY-MM-DD') : '';
  var checkoutDate = Date.parse(checkout) ? moment(checkout).format('YYYY-MM-DD') : '';
  $form.find('[name=checkin]').val(checkinDate);
  $form.find('[name=checkout]').val(checkoutDate);
}

function setCheckInOutUI(checkin, checkout) {
  var output = ''
  var $reservationUI = $('#booking_package_reservation .ui-reservation')
  var $nightUI = $('#booking_package_reservation .ui-night')
  var checkinDate = Date.parse(checkin) ? moment(checkin).format('ddd, DD MMM YYYY') : null
  var checkoutDate = Date.parse(checkout) ? moment(checkout).format('ddd, DD MMM YYYY') : null

  if (checkinDate) {
    /* ถ้ามีค่า checkin */
    output += `<span class="value-checkin">${checkinDate}</span>`
  }
  else {
    /* ถ้าไม่มีค่า checkin */
    output = `<span class="text-muted">${TL.i18n["no-reservation-date-select"]}</span>`
  }

  if (checkoutDate) {
    /* ถ้ามีค่า checkout */
    var nights = getNights(checkin, checkout)
    output += '<i class="fal fa-long-arrow-right mx-2"></i>'
    output += `<span class="value-checkout">${checkoutDate}</span>`
    $nightUI.html(`<span class="value">${printNights(nights)}</span>`)
  }
  else {
    $nightUI.empty()
  }

  $reservationUI.html(output);
}

/**
 * Get number of nights by different of two date
 * @param {string} timeFrom ค่าเวลาเริ่มต้นในรูปแบบ: YYYY-MM-DD
 * @param {string} timeTo ค่าเวลาสิ้นสุดในรูปแบบ: YYYY-MM-DD
 *
 * @return {number} จำนวนวันที่ห่างกัน โดยจะปัดเศษขึ้นทุกกรณีหากตัวเลขไม่ลงตัว
 */
function getNights( timeFrom, timeTo ) {
  var diff = new Date(timeTo) - new Date(timeFrom);
  return Math.ceil(diff / 1000 / 60 / 60 / 24);
}

/**
 * Print number of nights in human read
 * @param {number} numofnight 
 *
 * @return {string}
 */
function printNights( numofnight ) {
  var unit = numofnight !== 1 ? TL.i18n["nights"] : TL.i18n["night"];
  return `${numofnight} ${unit}`;
}

$packageCalendarPrev.on('click', () => packageCalendar.prev());
$packageCalendarNext.on('click', () => packageCalendar.next());

$('#promocode_collapse').on('shown.bs.collapse', event => {
  $(event.currentTarget).find('input').get(0).focus();
});

$('#booking_package_form').on('submit', function(event) {
  event.preventDefault();
  var FORMDATA = $(this).serializeArray();
  console.log(FORMDATA);
});

/**
 * Render calendar picker function
 * @param {string} MODE desktop | mobile
 */
var renderBookingCalendar = function( MODE ) {
  var switchMode = ( MODE ) => {
    var length = $packageCalendar.find('.calendar').length;
    var VIEW = new Date(packageCalendar.getRange()[0]) || packageCalendar.settings.minDate;
    var numOfMonth = {
      desktop: 2,
      mobile: 12
    };

    switch (MODE) {
      case 'desktop':
        while (length !== numOfMonth[MODE]) {
          if (length > numOfMonth[MODE]) {
            $packageCalendar.find('.tl-datepicker__group .calendar').eq(length - 1).remove(); length--;
          } else {
            $packageCalendar.find('.tl-datepicker__group').append('<div class="calendar" />'); length++;
          }
        }
        packageCalendar.reInit();
        VIEW = Date.parse(packageCalendar.getRange()[0])
          ? new Date(packageCalendar.getRange()[0]) || new Date(packageCalendar.settings.minDate)
          : new Date();
        packageCalendar.goto( VIEW.getFullYear(), VIEW.getMonth() );
        break;
      case 'mobile':
        while (length !== numOfMonth[MODE]) {
          if (length > numOfMonth[MODE]) {
            $packageCalendar.find('.tl-datepicker__group .calendar').eq(length - 1).remove(); length--;
          } else {
            $packageCalendar.find('.tl-datepicker__group').append('<div class="calendar" />'); length++;
          }
        }
        packageCalendar.reInit();
        VIEW = new Date(packageCalendar.settings.minDate) || new Date();
        packageCalendar.goto( VIEW.getFullYear(), VIEW.getMonth() );

        if ($packageCalendar.find('.is-select').length) {
          var _container = $packageCalendar.find('.tl-datepicker__group')[0];
          var _target = $packageCalendar.find('.is-select').eq(0).parents('.calendar')[0];
          _container.scroll({
            top: _target.offsetTop - 14
          })
        }
        break;
    }
  }

  switchMode(MODE)
}

/**
 * Booking Panel Popup
 * @since 209-07-12
 */
var showBookingPanel = function(target) {
  $.magnificPopup.open({
    items: {
      type: 'inline',
      src: target
    },
    mainClass: 'component-popup mfp-slide-up booking-popup',
    removalDelay: 200,
    fixedContentPos: 'fixed',
    callbacks: {
      open() {
        calendarScrollable.recalculate()
        if ($packageCalendar.find('.is-select').length) {
          var _target = $packageCalendar.find('.is-select').eq(0).parents('.calendar').get(0);
          calendarScrollable.contentWrapperEl.scroll({
            top: _target.offsetTop - 14
          })
        }
      }
    }
  });
}

// Init simplebar
var calendarScrollable = new SimpleBar($form.find('.body')[0]);

// Check device viewport and render calendar
var MODE = window.innerWidth >= 768 ? 'desktop' : 'mobile';
renderBookingCalendar(MODE);

// Debounce function for check device viewport in background
var timer;
window.addEventListener('resize', () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    var NEWMODE = window.innerWidth >= 768 ? 'desktop' : 'mobile';
    if (NEWMODE !== MODE) {
      renderBookingCalendar(NEWMODE)
      MODE = NEWMODE
    }
  }, 200)
});

// By event for trigger reservation panel
$(document).on('touchend click', '.js-booking-panel', function(event) {
  event.preventDefault()
  var source = $(this).data('target')
  showBookingPanel(source)
})

/**
 * #package_countdown callback
 * @since 2019-07-08
 */
 $('#package_countdown').on('update.countdown', function() {
  // Trigger every second update
  // console.log('Update');
});

$('#package_countdown').on('finish.countdown', function() {
  // Trigger when time finish
  console.log('Finish');
});

};

if (window.InitCalendar === undefined) {
  window.InitCalendar = initCalendar;
}
  window.InitCalendar();
  
var handleDescriptionDisplay = function () {

    var minimized_elements = $('.description-minimize');
    var maxLength = 299;
    var text_less;
    var text_more;

    //Get information
    var description = minimized_elements.html();
    if (description === undefined) {
        return;
    }

    var length = description.length;
    if (length > maxLength) {
        text_less = description.slice(0, maxLength);
        text_more = description.slice(maxLength, length);

    } else {
        return;
    }

    //Get label
    var more_details = $('.label-more-details').text();
    var less_details = $('.label-less-details').text();

    //Set display
    minimized_elements.html(
            text_less + '<span> ... </span><a href="#" class="more landing-page-description">' + more_details + '</a>' +
            '<span style="display:none;">' + text_more + ' <a href="#" class="less landing-page-description">' + less_details + '</a></span>'
            );


    $('a.more', minimized_elements).click(function (event) {
        event.preventDefault();
        $(this).hide().prev().hide();
        $(this).next().show();
    });

    $('a.less', minimized_elements).click(function (event) {
        event.preventDefault();
        $(this).parent().hide().prev().show().prev().show();
    });
}

if (window.HandleDescriptionDisplay === undefined) {
    window.HandleDescriptionDisplay = handleDescriptionDisplay;
}
window.HandleDescriptionDisplay();
